export function escapeCSVField(field) {
  if (field === null || field === undefined) {
    return '';
  }
  const stringField = String(field);
  // If field contains comma, quote, or newline, wrap in quotes and escape quotes
  if (
    stringField.includes(',') ||
    stringField.includes('"') ||
    stringField.includes('\n')
  ) {
    return `"${stringField.replace(/"/g, '""')}"`;
  }
  return stringField;
}

// Builds a CSV blob (with a UTF-8 BOM for Excel compatibility) from headers +
// pre-escaped row strings, and triggers a browser download — no library
// dependency, since this is just a Blob + anchor-click download.
export function downloadCSV({ headers, rows, filename }) {
  const csvContent = [headers.join(','), ...rows].join('\n');
  const BOM = '﻿';
  const blob = new Blob([BOM + csvContent], {
    type: 'text/csv;charset=utf-8;',
  });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
